<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Регионы
                </span>
                <!-- <v-icon  @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="var(--app-dark-blue-1)">mdi-information</v-icon> -->
            </div>
            <!-- <v-menu
                v-model="showInfo"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                >
                <v-card min-width="300px"  min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Котировки»
                    </div>
                    <div class="menu-container-text">
                        Блок с графиком котировок VTBR, можно скрывать при острой необходимости
                    </div>
                  
                </div>
                    
                </v-card>
            </v-menu> -->
            <v-spacer></v-spacer>
            <v-btn @click="dialog = true" class=" button-accept">
                + Добавить регион
            </v-btn>

        </div>
        <div>

            <div class="table-container">
                <v-data-table :headers="RegionsHeaders" :items="regions" item-key="id" class="elevation-0 main-table"
                    :disable-pagination="true" :hide-default-footer="true" fixed-header>

                    <template v-slot:body="props">
                        <tbody>
                            <tr v-for="(item, index) in props.items" :key="index">
                                <td> {{ item.name }}</td>

                                <td class="text-right">
                                    <v-icon @click="goToDetail(item)">mdi-pencil-outline</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </template>

                </v-data-table>
            </div>
        </div>
        <v-divider></v-divider>

        <v-dialog width="570px" height="auto" persistent v-model="dialog">
            <v-card width="570px" height="auto" class="rounded-0">
                <v-form ref="formFirst">
                    <v-card-title class="dialog-title">
                        <span v-if="selectedItem && selectedItem.id" class="title">Редактировать регион</span>
                        <span v-else class="title">Добавить регион</span>
                        <v-icon @click="closeDialog">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <v-text-field style="margin-top: 20px" label="Название" required type="text" outlined :rules="rules"
                            v-model="selectedItem.name" :error-messages="errorMessage" ref="input_text"></v-text-field>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn style="width: 120px !important" @click="saveRegion" class="button-accept">
                            Сохранить
                        </v-btn>
                        <v-btn v-if="selectedItem && selectedItem.id" @click="dialogDelete = true"
                            style="width: 120px !important" class="button-accept-outlined" outlined
                            color="var(--app-red-1)">
                            Удалить
                        </v-btn>

                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
            <v-card>
                <v-card-title class="dialog-title">
                    <span class="title">Точно хотите удалить регион?</span>
                    <v-icon @click="dialogDelete = false;">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions class="dialog-buttons">
                    <v-btn @click="dialogDelete = false;" style="width: 120px" outlined color="var(--app-green-1)">
                        Нет
                    </v-btn>
                    <v-btn @click="deleteRegion" style="width: 120px" outlined color="var(--app-red-1)">
                        Да
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>


export default {

    data: () => ({
        dialog: false,
        dialogDelete: false,
        showInfo: false,
        x: null,
        y: null,
        regions: [],
        rules: [value => !!value || 'Обязательно к заполнению'],

        selectedItem: {},


        RegionsHeaders: [
            {
                text: 'Название',
                sortable: false,
            },
            {
                text: '',
                sortable: false,

            },

        ],
        errorMessage: []
    }),
    watch: {
        'selectedItem.name'() {
            this.errorMessage = []
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false
            this.selectedItem = {}
            this.$refs.formFirst.reset()
            this.$refs.formFirst.resetValidation()
        },
        deleteRegion() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/region', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    regionId: this.selectedItem.id
                }
            })
                .then(() => {

                    this.dialogDelete = false
                    this.closeDialog()
                    this.getRegions()
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        saveRegion() {
            if (this.$refs.formFirst.validate()) {
                const newArr = this.regions.filter(item => item.name == this.selectedItem.name)

                if (newArr.length == 0) {
                    this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/region', {
                        name: this.selectedItem.name,
                        regionId: this.selectedItem.id ? this.selectedItem.id : ''
                    }, {
                        headers: {
                            'authorization': this.$store.getters.adminPanelHeaderAuth
                        }
                    })
                        .then(() => {
                            this.selectedItem = {}
                            this.dialog = false
                            this.getRegions()

                        })
                        .catch(err => {
                            this.$store.commit('errorSet', true)
                            this.$store.commit('errorTextSet', err)
                        })
                }
                else {
                    this.errorMessage = ['Такое название уже существует']
                }


            }

        },
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        goToCreate() {
            this.$router.push({ name: 'CreateCategories' })

        },
        goToDetail(item) {
            this.selectedItem = Object.assign({}, item)
            this.dialog = true

        },
        getRegions() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/region/list', {
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.optionTable = res.data.optionTable;
                    this.regions = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },



    },
    created() {

        this.getRegions()
    },
}
</script>
<style lang="scss" scoped>
.table-container {
    height: calc(100vh - 190px);

    .main-table {
        height: calc(100vh - 190px) !important;
        min-height: calc(100vh - 190px) !important;
        max-height: calc(100vh - 190px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>